// extracted by mini-css-extract-plugin
export default {"modal_content":"rejectModal_modal_content__UyE1e","top":"rejectModal_top__Fj3zI"};